import {
  isActivityLibrary, isActivityOnetime, isActivityPlatformVideo, isActivityPlatformWorksheet,
  LessonActivity,
  LessonActivityLibrary, LessonActivityOnetime,
  LessonActivityPlatformVideo,
  LessonActivityPlatformWorksheet, StudentAnsAttempt
} from "./lesson-activity.types"


interface LessonActivityTraits {
  get questionTotal(): number;
  get coinsTotal(): number;
  get timeTotal(): number;
  get attemptedQuestionCount(): number;
}

function calculateTotalTime(attempts: StudentAnsAttempt[]) {
  let total = 0;
  (attempts || []).forEach((attempt) => {
    total += attempt.submitted_on;
  })
  return total;
}

function createLessonTraits(activity: LessonActivity): LessonActivityTraits {
  if(isActivityLibrary(activity)) {
    return new LibraryActivityTraits(activity);
  }
  else if(isActivityPlatformWorksheet(activity)) {
    return new PlatformWorksheetTraits(activity);
  }
  else if(isActivityPlatformVideo(activity)) {
    return new PlatformVideoTraits(activity);
  }
  else if(isActivityOnetime(activity)) {
    return new OnetimeActivityTraits(activity)
  }

  throw new Error(`Unable to create LessonActivityTraits for type ${activity.activity_type}`);
}

class LibraryActivityTraits implements LessonActivityTraits {

  constructor(private activity: LessonActivityLibrary) {
  }

  get questionTotal() {
    const questions =  this.activity.LessonActivitiesQuestions.flatMap(e=>e.question);
    return questions.length;
  }

  get coinsTotal() {
    return this.activity.activity_node?.[0]?.coins || 0;
  }

  get timeTotal() {
    const attempts =
      this.activity.LessonActivitiesQuestions
        .flatMap(e=>e.question)
        .flatMap( e=> e.StudentAnsAttempts);
    return calculateTotalTime(attempts);
  };

  get attemptedQuestionCount() {
    const questionWithAttempts =
      this.activity.LessonActivitiesQuestions
        .flatMap(e=>e.question)
        .filter( e=> e?.StudentAnsAttempts?.length > 0)
    return questionWithAttempts.length;
  }
}


class PlatformWorksheetTraits implements LessonActivityTraits {

  constructor(private activity: LessonActivityPlatformWorksheet) {
  }

  get questionTotal() {
    const questions =  this.activity.LessonActivitiesQuestions.flatMap(e=>e.question);
    return questions.length;
  }

  get coinsTotal() {
    return 20;
  }
  get timeTotal() {
    const attempts =
      this.activity.LessonActivitiesQuestions
        .flatMap( e=> e.StudentAnsAttempts);
    return calculateTotalTime(attempts);
  };

  get attemptedQuestionCount() {
    const questionWithAttempts =
      this.activity.LessonActivitiesQuestions
        .filter( e=> e?.StudentAnsAttempts?.length > 0)
    return questionWithAttempts.length;
  }

}

class PlatformVideoTraits implements LessonActivityTraits {

  constructor(private activity: LessonActivityPlatformVideo) {
  }

  get questionTotal() {
    const questions =  this.activity.LessonActivitiesQuestions.flatMap(e=>e.question);
    return questions.length;
  }

  get coinsTotal() {
    return 2;
  }

  get timeTotal() {
    const attempts =
      this.activity.LessonActivitiesQuestions
        .flatMap(e=>e.question)
        .flatMap( e=> e.StudentAnsAttempts);
    return calculateTotalTime(attempts);
  };

  get attemptedQuestionCount() {
    const questionWithAttempts =
      this.activity.LessonActivitiesQuestions
        .flatMap(e=>e.question)
        .filter( e=> e?.StudentAnsAttempts?.length > 0)
    return questionWithAttempts.length;
  }

}


class OnetimeActivityTraits implements LessonActivityTraits {

  constructor(private activity: LessonActivityOnetime) {
  }

  get questionTotal() {
    const questions =  this.activity.LessonActivitiesQuestions.flatMap(e=>e.question);
    return questions.length;
  }

  get coinsTotal() {
    return this.activity.activity_node?.[0]?.coins || 0;
  }

  get timeTotal() {
    const attempts =
      this.activity.LessonActivitiesQuestions
        .flatMap(e=>e.question)
        .flatMap( e=> e.StudentAnsAttempts);
    return calculateTotalTime(attempts);
  };

  get attemptedQuestionCount() {
    const questionWithAttempts =
      this.activity.LessonActivitiesQuestions
        .flatMap(e=>e.question)
        .filter( e=> e?.StudentAnsAttempts?.length > 0)
    return questionWithAttempts.length;
  }
}

export const LessonActivityTraits = {
  create: createLessonTraits
}